import styled from 'styled-components';

const ChatContainer = styled.div`
  margin-top: ${({ from }) => (from === 'Home' ? '24px;' : '0;')};
`;

export default ChatContainer;
